import { CompoundEntityRef } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';
import crossFetch from 'cross-fetch';
import { techDocsPageInfoSchema, TechDocsPageInfo } from '../types';
import { TechDocsMetadataApi } from './TechDocsMetadataApi';

// isomorphic types that don't require @backstage/core-plugin-api
type DiscoveryApi = { getBaseUrl(pluginId: string): Promise<string> };
type FetchApi = { fetch: typeof fetch };

export class TechDocsMetadataClient implements TechDocsMetadataApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  public constructor(deps: {
    discoveryApi: DiscoveryApi;
    fetchApi?: FetchApi;
  }) {
    const { discoveryApi, fetchApi } = deps;
    this.discoveryApi = discoveryApi;
    this.fetchApi = fetchApi ?? { fetch: crossFetch };
  }

  public async getTechDocsMetadata(
    entityRef: CompoundEntityRef,
    path: string,
  ): Promise<TechDocsPageInfo> {
    const baseUrl = await this.discoveryApi.getBaseUrl('appfolio-techdocs');
    const entitySegments = [entityRef.namespace, entityRef.kind, entityRef.name]
      .map(encodeURIComponent)
      .join('/');
    const url = path
      ? `${baseUrl}/metadata/entity/${entitySegments}/${path}`
      : `${baseUrl}/metadata/entity/${entitySegments}`;
    const response = await this.fetchApi.fetch(url);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    const data = await response.json();
    return techDocsPageInfoSchema.parse(data);
  }
}
